import FloatingMessenger from "./floating-messenger"

export default function CustomMargin({children, className = ''}){
    return(
        <div className={`max-w-maxScreen m-auto ${className}`}>
            <FloatingMessenger/>
            {children}
        </div>
    )
}